<template>
  <div class="relative mt-20 mb-20 max-w-screen-sm left-1/2 -translate-x-1/2">
    <div class="flex flex-col flex-wrap content-center">
      <div>
        <h2>Hi there, what's your name?</h2>
        <p>Let's get to know each other 😄</p>
      </div>
      <div class="mt-6 mb-2">
        <!-- TODO: Move name input to a separate component. -->
        <input type="text" name="name" v-model="name" @blur="validateName" v-on:input="validateName" class="w-full" placeholder="Name"/>
      </div>
      <!-- TODO: Use LoadingButton component for a button that loads. -->
      <button @click="goToNext()" :disabled="error || !name || loading" class="inline-flex items-center place-content-center">
        <svg v-if="loading" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span v-else>Next →</span>
      </button>
    </div>
  </div>
</template>

<script>
import User from '@/models/user'
import { mapStores } from 'pinia'
import { useUserStore } from '@/stores/user'

export default {
  name: 'OnboardingName',
  data() {
    return {
      error: false,
      loading: false,
      name: undefined,
    }
  },
  beforeMount() {
    this.loadName()
  },
  methods: {
    validateName() {
      // TODO: Field validation for name.
    },
    loadName() {
      this.name = this.userStore.user?.name ?? ''
    },
    async goToNext() {
      this.loading = true
      // If no user is currently authenticated, create new user.
      if (!this.userStore.user) {
        await User.create(this.name)
      } else {
        this.userStore.user.name = this.name
        await this.userStore.user.save()
      }
      this.$router.push('/onboarding/goal')
      this.loading = false
    }
  },
  computed: {
    ...mapStores(useUserStore),
  },
}
</script>